module.exports = __webpack_public_path__ + "img/certificate_04@2x.bdc472bd.png";